import { H2Span } from "@constellation-academy/epic-ui";
import { ConfirmDialog } from "primereact/confirmdialog";
import { useCallback } from "react";
import { useRefetchableFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { dispatchInclusions_MessageDispatchFragment$key } from "@relay/dispatchInclusions_MessageDispatchFragment.graphql";
import { dispatchInclusions_Refetch } from "@relay/dispatchInclusions_Refetch.graphql";
import { MESSAGE_DISPATCH_FRAGMENT } from "./dispatch-inclusions.graphql";
import { DispatchInclusionsProps } from "./dispatch-inclusions.types";
import { DispatchConditionDropdown } from "../dispatch-condition-dropdown";
import { DispatchConditionPreview } from "../dispatch-conditions-preview";

export const DispatchInclusions = ({ messageDispatchFragmentRef }: DispatchInclusionsProps) => {
	const { t } = useTranslation("common");
	const [messageDispatch, refetch] = useRefetchableFragment<
		dispatchInclusions_Refetch,
		dispatchInclusions_MessageDispatchFragment$key
	>(MESSAGE_DISPATCH_FRAGMENT, messageDispatchFragmentRef ?? null);

	const refresh = useCallback(() => {
		refetch({}, { fetchPolicy: "network-only" });
	}, []);
	return (
		<>
			<H2Span>{t("messageDispatch.inclusions")}</H2Span>
			<ConfirmDialog />
			<DispatchConditionDropdown
				isInclusion
				onChange={refresh}
				messageDispatchFragmentRef={messageDispatch}
			/>
			<DispatchConditionPreview
				onChange={refresh}
				messageDispatchFragmentRef={messageDispatch}
			/>
		</>
	);
};
